/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Dashboard components
import {
  Button,
  Card,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
} from "@mui/material";
import FairData from "layouts/tables/data/fairTableData";
import { useEffect, useState } from "react";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import moment from "moment";

import PropTypes from "prop-types";
import { notify } from "utilities";
import { updateLocation } from "api";
import { createLocation } from "api";
import MDTypography from "components/MDTypography";

function AddLocation({ visible, onClose, onSubmit, fairData, locationData }) {
  const [name, setName] = useState("");
  const [isMainEntry, setIsMainEntry] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    setName(locationData?.name || "");
    setIsMainEntry(locationData?.isMainEntry || false);
  }, []);

  const handleAdd = () => {
    if (name === "") {
      setIsSubmitted(true);
    } else {
      setIsSubmitted(false);
      var params = {
        name: name.trim(),
        isMainEntry: isMainEntry,
      };

      if (locationData) {
        updateLocationApi(params, locationData?._id);
      } else {
        params.fair = fairData?._id;
        createLocationApi(params);
      }
    }
  };

  const updateLocationApi = (params, id) => {
    updateLocation({
      params: params,
      id: id,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            onSubmit && onSubmit();
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const createLocationApi = async (params) => {
    createLocation({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            onSubmit && onSubmit();
          }
        }
      })
      .catch((e) => {});
  };

  const handleCheck = (event) => {
    setIsMainEntry(event.target.checked);
  };

  return (
    <Dialog open={visible}>
      <DialogTitle>Location</DialogTitle>
      <DialogContent>
        <MDBox gap={2} mt={1} mb={1}>
          <MDInput
            label={
              <>
                Location Name
                <span style={{ color: "red" }}>*</span>
              </>
            }
            type="text"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            helperText={isSubmitted && !name ? "Location name is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
        </MDBox>
        <MDBox display="flex" alignItems="center">
          <Checkbox checked={isMainEntry} onClick={() => setIsMainEntry(!isMainEntry)} />
          <MDTypography
            variant="button"
            fontWeight="regular"
            color="text"
            sx={{ cursor: "pointer" }}
            onClick={() => setIsMainEntry(!isMainEntry)}
          >
            Main Entry
          </MDTypography>
        </MDBox>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose && onClose();
            setIsSubmitted(false);
            setName("");
          }}
          color="error"
          variant="contained"
        >
          Cancel
        </Button>
        <MDButton onClick={handleAdd} color="info">
          Save
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

AddLocation.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fairData: PropTypes.object,
  locationData: PropTypes.object,
};

export default AddLocation;
